<template>
  <div data-test-id="AgeAndGender">
    <div class="d-flex">
      <age :selected-age="adaptedAge" @age-updated="ageUpdated"></age>
      <gender :selected-gender="gender" @gender-updated="genderUpdated"></gender>
    </div>
  </div>
</template>

<script>
import Age from "./Age";
import Gender from "./Gender";
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";

const unitToAgePeriod = { Years: 3, Months: 2, Weeks: 1 };
const agePeriodToUnit = { 3: "Years", 2: "Months", 1: "Weeks" };

const adapter = {
  in: (object) => {
    return {
      value: object.age,
      unit: agePeriodToUnit[object.agePeriod] || "",
    };
  },

  out: (object) => {
    return {
      age: object.value || null,
      agePeriod: unitToAgePeriod[object.unit] || null,
    };
  },
};

export default {
  name: "AgeAndGender",

  components: { Age, Gender },

  props: {
    age: {
      default: null,
      type: Number,
    },

    agePeriod: {
      default: 3,
      type: Number,
    },

    gender: {
      default: "",
      type: String,
    },
  },

  computed: {
    adaptedAge() {
      return adapter.in({
        age: this.age,
        agePeriod: this.agePeriod,
      });
    },
  },

  methods: {
    ageUpdated(age) {
      this.$emit(CaseEvent.MODIFY, {
        eventType: CaseUpdateEventType.age,
        data: adapter.out(age),
      });
    },

    genderUpdated(gender) {
      this.$emit(CaseEvent.MODIFY, { eventType: CaseUpdateEventType.gender, data: gender });
    },
  },
};
</script>

<style scoped>
.d-flex {
  gap: 1rem;
}
</style>
